import { HTMLAttributes, ReactElement } from 'react'

export type TDefinitionFields<T> = {
  // Header
  label: string // Titre header de la colonne
  labelElement?: ReactElement
  indexName: keyof T // Nom du champs des data, => le value dans la method format
  isSortable?: boolean // Permet de definir si une colonne est triable ou non
  sortField?: keyof T // Le nom du champs a trier dans les data car il peut etre different de l'indexName. Obligatoire si le champs est triable
  // Row  value
  format?: (values: T, isHover: boolean, index: number) => string | ReactElement // Permet de modifer la data avant affichage
  styles?: (values: T, isHover: boolean) => HTMLAttributes<HTMLDivElement>['style'] // Surcharger le style de l'affichage de la value
  onClick?: (values: T, index: number) => void // action lors du click sur une data
}[]

export interface ITableInfinite<T> {
  firstColumn?: {
    format?: (values: T, isRowHover: boolean, index: number) => string | ReactElement
    styles?: HTMLAttributes<HTMLDivElement>['style']
    onClick?: (values: T, index: number) => void
  }
  definitionFields: TDefinitionFields<T>
  data: (T & Required<{ id: string | number }>)[] // Le tabelau de data.  Doit contenir au moins id
  nextPage: () => void
  isQueriedAllCompleted: boolean
  onSort?: (key: keyof T, order: Order) => void
  activeSorts?: { key: string; order: Order }[]
  displayedFields?: (keyof T)[]
  setDisplayedFields?: (displayedFields: (keyof T)[]) => void
  displayError?: string
  exportFileName?: string
  exportFields?: TDefinitionFields<T>
  getAll?: () => void

  isLoading?: boolean
}

export enum Order {
  ASC = 'asc',
  DESC = 'desc',
}
